module.exports = __webpack_public_path__ + "img/sell-from-home.f6e8a596.svg";